import { makeObservable, observable } from 'mobx'

import { EMPTY_NUMBER_ID, EMPTY_STRING_ID } from '@/constant/common'

import { DTO } from '../DTO'

export class SmsTemplate extends DTO implements res.SmsTemplate {
  id: res.SmsTemplate['id'] = EMPTY_NUMBER_ID
  academyId: res.SmsTemplate['academyId'] = EMPTY_STRING_ID
  type: res.SmsTemplate['type'] = 'CUSTOM'
  title: res.SmsTemplate['title'] = ''
  content: res.SmsTemplate['content'] = ''
  templateSendingType: res.SmsTemplate['templateSendingType'] = null

  constructor(data?: res.SmsTemplate) {
    super()

    makeObservable(this, {
      id: observable,
      academyId: observable,
      type: observable,
      title: observable,
      content: observable,
    })
    if (data) {
      this.id = data.id
      this.academyId = data.academyId
      this.type = data.type
      this.title = data.title
      this.content = data.content
      this.templateSendingType = data.templateSendingType
    }
  }
}
